module.exports = __webpack_public_path__ + "static/media/batches-active.d94e824f.svg";